import videojs from 'video.js';

import 'video.js/dist/video-js.css';
import PausedOverlay from './PausedOverlay';

class VideoPlayerDispenserHelper {
    constructor() {
        this.BLANK_VIDEO_PATH = 'assets/videos/blank.mp4';
        this.BLANK_IMAGE_PATH = 'assets/videos/blank.png';

        this.videoPlayers = {
            // -- add the video players used by the game here (video tag id)--
            mainVideoPlayer: 'mainVideoPlayer'
        }

        this._pausedOverlay = new PausedOverlay(document.getElementById('pausedOverlay'), document.getElementById('resumeButton'), document.getElementById('skipVideoButton'));
    }

    /**
     * Gets a video player by name
     * @return {videojs.Player} The video player.
     */
    getVideoPlayer(name) {
        return this.videoPlayerInstances[name].player;
    }

    /**
     * Gets the wrapper by video player name
     * @return {HTMLDivElement} The wrapper.
     */
    getVideoWrapper(name) {
        return this.videoPlayerInstances[name].wrapper;
    }

    /**
     * Gets the overlay that is shown when the video is paused
     * @return {PausedOverlay} The overlay.
     */
    getPausedOverlay() {
        return this._pausedOverlay;
    }

    /**
     * Initializes video players. Should be called as soon as the web app starts.
     * @return {Promise<void>} A promise that will be resolved when the video players are ready.
     */
    initialize() {
        return new Promise(resolve => {
            this.videoPlayerInstances = {};
            for (var key in this.videoPlayers) {
                var videoPlayerName = this.videoPlayers[key];

                var playerInstance = videojs(videoPlayerName, {
                    controls: false,
                    src: this.BLANK_VIDEO_PATH,
                    html5: {
                        nativeTextTracks: false
                    },
                    // leave `fluid` to false, responsiveness is handled in css with the 'ranj-video-contain' class
                }, resolve); // resolve when the video player is ready to be used

                this.videoPlayerInstances[videoPlayerName] = {
                    player: playerInstance,
                    wrapper: document.getElementById(videoPlayerName + 'Wrapper')
                };
            }
        }).finally(_ => {
            document.addEventListener("click", () => {
                this.initializeAutoplay();
            }, { once: true });
        });
    }

    /**
     * Loads and plays the blank video in order to prepare the video players for autoplay on the mobile devices.
     * Must be called by a user interaction (e.g., mouse click).
     * This means that the beginning of the call stack for this call should have a user interaction.
     * @return {void}
     */
    initializeAutoplay() {
        console.log(`[VideoPlayerDispenserHelper] Initializing autoplay.`);

        for (var key in this.videoPlayers) {
            var videoPlayerName = this.videoPlayers[key];
            var playerInstance = this.getVideoPlayer(videoPlayerName);

            playerInstance.src(this.BLANK_VIDEO_PATH);
            playerInstance.poster(this.BLANK_IMAGE_PATH);

            playerInstance.play();
        }
    }

    isInitialized() {
        return !!this.videoPlayerInstances;
    }
};

const instance = new VideoPlayerDispenserHelper();
export default instance;